module.exports = __webpack_public_path__ + "assets/img/brice.fd9eb1a0.png";